import Accordion from './src/JsmAccordion.vue'

Accordion.install = (Vue) => {
  Vue.component(Accordion.name, Accordion)
}

export default Accordion
